export function ScanlinesOverlay() {
  return (
    <div className="pointer-events-none absolute inset-0 scanlines rounded-2xl opacity-20 mix-blend-multiply z-100" />
  )
}
